import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './styles/custom.scss';
import './directives';
Vue.config.productionTip = false;

console.log(`[DP] Version: ${process.env.VUE_APP_DP_VERSION}`);

export const eventBus = new Vue();
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
